import { IColumn } from "../models/IColumn";
import { IInternalColumn } from "../models/IInternalColumn";

const groupDataSourceBy = (key: any) => (array: any) =>
array.reduce((objectsByKeyValue: any, obj: any) => {
  const value = obj[key];
  objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
  return objectsByKeyValue;
}, {});

const filterByColumnName = (fieldName:string,columns: IInternalColumn[]):string =>{
  var result = '';
   for(var i=0;i < columns.length;i++){
       if(columns[i].fieldName === fieldName)
       {
           var col = columns[i];
           return col.headerName;
       }
         
   }
  return result;
}

export {groupDataSourceBy,filterByColumnName};